<jw-modal id="vorAbsenceInfoModal" class="jobInfoDrawer">
  <div class='jobInfoDrawerLayout'>
    <div class='jobInfoDrawerHeader'>
      @if (this.type === 'vor') {
        <h1 class='header'>Vehicle Off Road</h1>
      }
      @if (this.type === 'absence') {
        <h1 class='header'>Driver Absence</h1>
      }
      <button class='btn btn-secondary btn-sm' (click)='this.close()' title='Close'><i class="fas fa-times"></i></button>
    </div>

    @if (this.record) {
      <div class='jobInfoDrawerBody'>
        @if (this.type === 'vor') {
          <div class='jobInfoRow'><span class='jobInfoLabel'>Vehicle</span><span class='jobInfoValue'>{{ this.record.vehicle.registration }}</span></div>
        }
        @if (this.type === 'absence') {
          <div class='jobInfoRow'><span class='jobInfoLabel'>Driver</span><span class='jobInfoValue'>{{ this.record.driver.firstName }} {{ this.record.driver.lastName }}</span></div>
        }
        <div class='jobInfoRow'><span class='jobInfoLabel'>Notes</span><span class='jobInfoValue'>{{ this.record.notes }}</span></div>
        <div class='jobInfoRow'><span class='jobInfoLabel'>Start Date</span><span class='jobInfoValue'>{{ this.record.startDate | date:'dd/MM/yy' }}</span></div>
        @if (this.type === 'vor') {
          <div class='jobInfoRow'><span class='jobInfoLabel'>Back on road</span><span class='jobInfoValue'>{{ getAbsenceEnd(this.record.endDate) }}</span></div>
        }
        @if (this.type === 'absence') {
          <div class='jobInfoRow'><span class='jobInfoLabel'>Returns</span><span class='jobInfoValue'>{{ getAbsenceEnd(this.record.endDate) }}</span></div>
        }
      </div>
    }
  </div>
</jw-modal>
